import NewAccountPopover from './NewAccountPopover';
import ConfirmationModel from './ConfirmationModel';
import NewAccountMppingPopover from './NewAccountMppingPopover';
import EditAccountPopover from './EditAccountPopover';
import React, { useEffect, useRef } from 'react'
import NewUserPopover from './NewUserPopover';
import NewNotification from './NewNotification';
import { ValidateEmail, getEmailList, getName } from './OEIUtils';
import EditNotificationPopover from './EditNotificationPopover';
import NewSalesforceMppingPopover from './NewSalesforceMappingPopover'
import NewOECentralMappingPopover from './NewOECentralMappingPopover'
import { AddCheckedList } from './AddCheckedList'
import { EDIT, EDIT_ACCOUNT, EDIT_CENTRAL_MAPPING, EDIT_NOTIFICATION, EDIT_SALESFORCE_MAPPING, EDIT_SYSTEM_MAPPING, EDIT_USER, EMPTY, END, MIDDLE, NEW_ACCOUNT, NEW_CENTRAL_MAPPING, NEW_NOTIFICATION, NEW_SALESFORCE_MAPPING, NEW_SYSTEM_MAPPING, NEW_USER } from './Constants';
import AccountLinkPopover from './AccountLinkPopover';
import OEMappingPopover from './OEMappingPopover';
import EditUserPopover from './EditUserPopover';
export default function OEIPopover(props) {
  const box = useRef(null);

  useOutsideAlerter(box, props);
  const [minimise, setMinimise] = React.useState(true);
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  const [emailId, setEmailId] = React.useState(EMPTY);
  const [error, setError] = React.useState(EMPTY);
  const [toggeleChecked, setToggleChecked] = React.useState(false);
  const [checkedListModel, openCheckedListModel] = React.useState(false);
  const managePopover = () => {
    cancelEmailAdding();
    setMinimise(!minimise);
  }
  const closePopover = (type) => {
    if (type === END) {
      cancelEmailAdding()
      props.setShowEdit(EMPTY)
      setMinimise(true);
      props.setClosePopover(true)
      props.onClickedMore(false)
      props.setMiddlePopoverName(EMPTY);
      openCheckedListModel(false)
    }
    else {
      props.setNewData({...props.newData,knovioCreationAccountId :props.newData.knovioAccountId})
      openCheckedListModel(false)
      props.setMiddlePopoverName(EMPTY);
    }
  }
  const edit = () => {
    props.setShowEdit(EMPTY)
    props.edit()
  }
  const clickOnAdd = () => {
    cancelEmailAdding();
    props.onclick(props.type);
  }
  const deleteFuction = () => {
    props.onClickedMore(true)
  }
  const submitDelete = (e) => {
    props.delete(props.editData)
    setOpenDeleteModal(false)
  }
  const setEmailid = (e) => {
    setError(EMPTY)
    setEmailId(e)
  }
  const onChangeToggle = () => {
    setToggleChecked(!toggeleChecked)
  }
  const duplicateCheck = (email, emailList) => {
    if (emailList && emailList.length > 0) {
      var list = getEmailList(emailList);
      const index = list.indexOf(email);
      if (index > -1) {
        setError('This emailId already added')
        return true;
      }
      else {
        return false;
      }
    }
  }
  const addEmail = () => {
    if (ValidateEmail(emailId)) {
      setError(EMPTY)
      if (props.popoverName === NEW_NOTIFICATION) {
        if (toggeleChecked) {
          if (!duplicateCheck(emailId, props.newData.emails) && (!duplicateCheck(emailId, props.newData.allEmails))) {
            props.setNewData({ ...props.newData, allEmails: props.newData.allEmails + `${props.newData.allEmails === EMPTY ? EMPTY : ','}` + emailId })
            setToggleChecked(false)
            props.setEmail(false);
            setEmailId(EMPTY)
          }
        }
        else {
          if (!duplicateCheck(emailId, props.newData.emails) && (!duplicateCheck(emailId, props.newData.allEmails))) {
            props.setNewData({ ...props.newData, emails: props.newData.emails + `${props.newData.emails === EMPTY ? EMPTY : ','}` + emailId })
            props.setEmail(false);
            setEmailId(EMPTY)
          }
        }
      } else {

        if (toggeleChecked) {
          if (!duplicateCheck(emailId, props.editData.emailAddresses) && (!duplicateCheck(emailId, props.editData.allEmailAddresses))) {
            props.setEditData({ ...props.editData, allEmailAddresses: props.editData.allEmailAddresses + `${props.editData.allEmailAddresses === EMPTY ? EMPTY : ','}` + emailId })
            setToggleChecked(false)
            props.setEmail(false);
            setEmailId(EMPTY)
          }
        }
        else {
          if (!duplicateCheck(emailId, props.editData.emailAddresses) && (!duplicateCheck(emailId, props.editData.allEmailAddresses))) {
            props.setEditData({ ...props.editData, emailAddresses: props.editData.emailAddresses + `${props.editData.emailAddresses === EMPTY ? EMPTY : ','}` + emailId })
            props.setEmail(false);
            setEmailId(EMPTY)
          }
        }

      }
    }
    else {
      setError('Please enter valid emailId')
    }
  }

  const cancelEmailAdding = () => { props.setEmail(false); setError(EMPTY); setEmailId(EMPTY); setToggleChecked(false) }
  return (
    <>
      {!(props.closePopover) ? <div className={`${props.type === MIDDLE ? 'sub-windows-host sub-windows-host-middle' : 'sub-windows-host'}`}>
        {minimise ? <div className="sub-window sub-window--maximized sub-window-container oe-popup-layout oe-popup-layout--sub-window-maximized">
          <div className="oe-popup-layout__header">
            <div className="oe-icon oe-icon__svg">
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 48 48" onClick={() => { closePopover(props.type) }}>
                <path d="M38.982 6.97a2 2 0 00-1.396.616L24 21.172 10.414 7.586A2 2 0 008.98 6.98a2 2 0 00-1.393 3.434L21.172 24 7.586 37.586a2 2 0 102.828 2.828L24 26.828l13.586 13.586a2 2 0 102.828-2.828L26.828 24l13.586-13.586a2 2 0 00-1.432-3.443z"></path>
              </svg>
            </div>
            <div className="oe-icon oe-icon__svg">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" onClick={() => { managePopover() }} viewBox="0 0 16 16"> <path d="M3.5 2C2.676 2 2 2.676 2 3.5v9c0 .824.676 1.5 1.5 1.5h9c.824 0 1.5-.676 1.5-1.5v-9c0-.824-.676-1.5-1.5-1.5zm0 1h9c.281 0 .5.219.5.5v9c0 .281-.219.5-.5.5h-9a.494.494 0 01-.5-.5v-9c0-.281.219-.5.5-.5zM5 10v1h6v-1z"></path>
              </svg>
            </div>
            <div className="oe-popup-layout__header-title-block">
              <div className="oe-popup-layout__header-title">{(props.middlePopoverName.length > 0 && props.type === MIDDLE) ? props.middlePopoverName : props.popoverName}</div>
            </div>
          </div>
          <div className="oe-popup-layout__body">
            <div className="oe-form">
              <div className="oe-form__body">
                {props.popoverName === NEW_ACCOUNT ?
                  <NewAccountPopover setErrors={props.setErrors} errors={props.errors} handleClickGenerate={props.handleClickGenerate} newData={props.newData} setNewData={props.setNewData} onclick={() => props.onclick()} generate={props.generate}></NewAccountPopover>
                  : (props.popoverName === NEW_SYSTEM_MAPPING && props.type === END) ?
                    <NewAccountMppingPopover middlePopoverName={props.middlePopoverName} removeMainItem={props.removeMainItem} setCheckedList={props.setCheckedList} setMiddlePopoverName={props.setMiddlePopoverName} setErrors={props.setErrors} errors={props.errors} newData={props.newData} setNewData={props.setNewData} openCheckedListModel={openCheckedListModel} checked={props.checked} setChecked={props.setChecked}></NewAccountMppingPopover> :
                    (props.popoverName === NEW_USER) ? <NewUserPopover setErrors={props.setErrors} errors={props.errors} handleClickGenerate={props.handleClickGenerate} setNewData={props.setNewData} setGenerate={props.setGenerate} generate={props.generate} newData={props.newData}></NewUserPopover> :
                    (props.popoverName === EDIT_USER) ? <EditUserPopover setErrors={props.setErrors} errors={props.errors} editUserData={props.editData} setEditUserData={props.setEditData}></EditUserPopover>:
                      (props.popoverName === EDIT_ACCOUNT) ? <EditAccountPopover setErrors={props.setErrors} errors={props.errors} editAccountData={props.editData} setEditAccountData={props.setEditData}></EditAccountPopover> :
                        (props.popoverName === EDIT_SYSTEM_MAPPING && props.type === END) ? <NewAccountMppingPopover middlePopoverName={props.middlePopoverName} type='edit' removeMainItem={props.removeMainItem} setCheckedList={props.setCheckedList} setMiddlePopoverName={props.setMiddlePopoverName} setErrors={props.setErrors} errors={props.errors} newData={props.newData} setNewData={props.setNewData} openCheckedListModel={openCheckedListModel} checked={props.checked} setChecked={props.setChecked}></NewAccountMppingPopover> :
                          (props.popoverName === NEW_NOTIFICATION) ? <NewNotification
                            cancelEmailAdding={cancelEmailAdding} emailId={emailId} setEmailid={setEmailid} error={error} setError={setError} toggeleChecked={toggeleChecked} onChangeToggle={onChangeToggle} addEmail={addEmail} newData={props.newData}
                            editData={props.editData} setNewData={props.setNewData} email={props.email} setEmail={props.setEmail} setErrors={props.setErrors} errors={props.errors}></NewNotification> :
                            (props.popoverName === EDIT_NOTIFICATION) ? <EditNotificationPopover addEmail={addEmail} emails={props.editData.emailAddresses} editData={props.editData} setEditData={props.setEditData}
                              cancelEmailAdding={cancelEmailAdding} emailId={emailId} setEmailid={setEmailid} error={error} setError={setError} toggeleChecked={toggeleChecked} onChangeToggle={onChangeToggle} newData={props.newData}
                              eventType={props.editData.notificationType} email={props.email} setEmail={props.setEmail} setErrors={props.setErrors} errors={props.errors}></EditNotificationPopover> :
                              (props.popoverName === NEW_SALESFORCE_MAPPING && props.type === END) ? <NewSalesforceMppingPopover middlePopoverName={props.middlePopoverName} removeMainItem={props.removeMainItem} type='New' setCheckedList={props.setCheckedList} newData={props.newData} setNewData={props.setNewData} setErrors={props.setErrors} errors={props.errors} setMiddlePopoverName={props.setMiddlePopoverName}></NewSalesforceMppingPopover> :
                                (props.middlePopoverName.length > 0 && props.type === MIDDLE && props.middlePopoverName === NEW_CENTRAL_MAPPING) ? <NewOECentralMappingPopover checkedListModel={checkedListModel} checkedList={props.checkedList} setCheckedList={props.setCheckedList} newData={props.newData} setNewData={props.setNewData} openCheckedListModel={openCheckedListModel} setErrors={props.setErrors} errors={props.errors}></NewOECentralMappingPopover> :
                                  (props.middlePopoverName.length > 0 && props.type === MIDDLE && props.middlePopoverName === EDIT_CENTRAL_MAPPING) ? <NewOECentralMappingPopover checkedListModel={checkedListModel} checkedList={props.checkedList} setCheckedList={props.setCheckedList} newData={props.newData} setNewData={props.setNewData} openCheckedListModel={openCheckedListModel} setErrors={props.setErrors} errors={props.errors}></NewOECentralMappingPopover> :
                                    (props.popoverName === EDIT_SALESFORCE_MAPPING && props.type === END) ? <NewSalesforceMppingPopover middlePopoverName={props.middlePopoverName} removeMainItem={props.removeMainItem} type='Edit' setNewData={props.setNewData} newData={props.newData} setCheckedList={props.setCheckedList} setErrors={props.setErrors} openCheckedListModel={openCheckedListModel} errors={props.errors} setMiddlePopoverName={props.setMiddlePopoverName}></NewSalesforceMppingPopover> :
                                      (props.popoverName === "New OEC Account Link" || props.popoverName === "Edit OEC Account Link") && props.type === END ? <AccountLinkPopover popoverType={props.popoverType} middlePopoverName={props.middlePopoverName} removeMainItem={props.removeMainItem} type= {props.popoverName === "New OEC Account Link" ?'New': 'Edit'} setCheckedList={props.setCheckedList} newData={props.newData} setNewData={props.setNewData} setErrors={props.setErrors} errors={props.errors} setMiddlePopoverName={props.setMiddlePopoverName}></AccountLinkPopover>
                                        : (props.middlePopoverName === "New System Mapping"||props.middlePopoverName === "Edit System Mapping") ? <OEMappingPopover popoverType={props.popoverType} middlePopoverName={props.middlePopoverName} removeMainItem={props.removeMainItem} type='New' setCheckedList={props.setCheckedList} newData={props.newData} setNewData={props.setNewData} setErrors={props.setErrors} errors={props.errors} setMiddlePopoverName={props.setMiddlePopoverName}></OEMappingPopover> : EMPTY}

              </div>
            </div>
          </div>
          <div className="oe-popup-layout__footer">
            <div className="buttons-block buttons-block--from-right">
              {((props.popoverName).includes(EDIT) && (props.type === END)) || (props.type === MIDDLE && props.middlePopoverName.includes(EDIT)) ?
                <button type="button" className="default-button default-button--fat default-button--confirm-safe" onClick={edit}>
                  <span>Apply</span>
                </button> :
                <button type="button" className="default-button default-button--fat default-button--confirm-safe" onClick={clickOnAdd}>
                  <span>Apply</span>
                </button>
              }
              <button type="button" className="default-button default-button--cancel default-button--fat" onClick={() => { closePopover(props.type) }}>
                <span>Cancel</span>
              </button>
              {((props.popoverName).includes(EDIT) && (props.type === END)&&props.popoverType!=='manage') ?
                <button onClick={() => { deleteFuction(); }} className={`options-button default-button default-button--fat default-button--options options-button--right-margin-auto ${props.clickedMore &&'options-button--active'}`} type="button">
                  <div ref={box} className="options-button__content">
                    <span className="options-button__label">More...</span>
                  </div>
                  {props.clickedMore && (props.popoverName).includes(EDIT) ? <div className={props.popoverName === EDIT_ACCOUNT? 'sub-windows-host3' :props.popoverName==='Edit OEC Account Link'?'sub-windows-host7': 'sub-windows-host4'}>
                    <button id='delete-action' onMouseDown={() => { setOpenDeleteModal(true); props.onClickedMore(false) }} className={props.popoverName === EDIT_NOTIFICATION ? 'default-button delete-button delete-notify-button' : 'default-button delete-button'}>{props.popoverName === EDIT_ACCOUNT ? 'Delete Account' : (props.popoverName === EDIT_SYSTEM_MAPPING) ? 'Delete Mapping' : (props.popoverName === EDIT_SALESFORCE_MAPPING) ? 'Delete Mapping' :(props.popoverName==='Edit OEC Account Link')?'Delete Link': (props.popoverName === 'Edit User')? 'Delete User' : 'Delete Notification'}</button>
                  </div> : EMPTY}
                </button> : EMPTY}
            </div>
          </div>
        </div> : <div className='sub-window'>
          <div className="sub-window__minimized-container">
            <div className="oe-popup-layout oe-popup-layout--sub-window-minimized">
              <div className="oe-popup-layout__header">
                <span title="New Event" className="overflow-ellipsis oe-popup-layout__header-title">{(props.middlePopoverName.length > 0 && props.type === MIDDLE) ? props.middlePopoverName : props.popoverName}</span>
                <div className="oe-popup-layout__controls">
                  <div className="oe-icon oe-icon__svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32" onClick={() => { managePopover() }}> <path d="M7 28c-1.6 0-3-1.4-3-3V7c0-1.6 1.4-3 3-3h18c1.6 0 3 1.4 3 3v18c0 1.6-1.4 3-3 3H7zm0-2h18c.6 0 1-.4 1-1V7c0-.6-.4-1-1-1H7c-.6 0-1 .4-1 1v18c0 .6.4 1 1 1zm3-14v-2h12v2H10z"></path>
                    </svg>
                  </div>
                  <div className="oe-icon oe-icon__svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 48 48" onClick={() => { closePopover(props.type) }}>
                      <path d="M38.982 6.97a2 2 0 00-1.396.616L24 21.172 10.414 7.586A2 2 0 008.98 6.98a2 2 0 00-1.393 3.434L21.172 24 7.586 37.586a2 2 0 102.828 2.828L24 26.828l13.586 13.586a2 2 0 102.828-2.828L26.828 24l13.586-13.586a2 2 0 00-1.432-3.443z"></path>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>} </div> : EMPTY}
      {openDeleteModal ? <ConfirmationModel open={openDeleteModal} deleteFunction={submitDelete} name={getName(props.popoverName)} setOpen={setOpenDeleteModal} /> : EMPTY}


      {checkedListModel ? <AddCheckedList name={props.popoverName} setErrors={props.setErrors} errors={props.errors} checkedList={props.checkedList} setCheckedList={props.setCheckedList} newData={props.newData} setNewData={props.setNewData} openCheckedListModel={openCheckedListModel}></AddCheckedList> : EMPTY}
    </>
  )
}
function useOutsideAlerter(ref, props) {
  useEffect(() => {
    function handleOutsideClick(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        props.onClickedMore(false);
      }
    }
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, [ref, props]);
}
